/*
 * This store uses the original create method from Zustand.
 * We do this here because we don't want to wipe this store
 * when we reset all other stores (for auth purposes)
 */
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface MagicLinkState {
    emailAddress: string | undefined;
}
interface MagicLinkStateStore extends MagicLinkState {
    setMagicLinkEmailAddress: (emailAddress: string) => void;
}

const initialState: MagicLinkState = {
    emailAddress: undefined,
};

export const useMagicLink = create<MagicLinkStateStore>()(
    devtools(
        persist(
            (set) => ({
                ...initialState,
                setMagicLinkEmailAddress: (emailAddress) => set({ emailAddress }),
            }),
            { name: 'magic-link-storage' },
        ),
    ),
);
